import { render, staticRenderFns } from "./AdminInvoiceChargeButton.vue?vue&type=template&id=3f38ba32"
import script from "./AdminInvoiceChargeButton.vue?vue&type=script&lang=js"
export * from "./AdminInvoiceChargeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports